module.exports = __webpack_public_path__ + "8d3e308564ad40e440a1cf4a15c48917.svg";